import React, { useState, useEffect, Fragment, useContext } from "react";
import Layout from "components/sales/layout/layout";
import { Button } from "react-bootstrap";
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import localization from 'assets/localization/localization';
import FileUpload from 'components/sales/fileUpload/fileUpload';
import { toast } from "react-toastify";
import Images from 'assets/images/imageData';
import ModalPop from 'components/sales/modal/modal';
import { Link } from 'react-router-dom';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';

const PayoutDetailsForBusinessHead = ({
  payoutDetailsWithId,
  match,
  getAllThePayoutDetailsWithId = [],
  documentUrlDataPublic,
  documentUploadUrlPublic,
  updateAllPayoutDetails,
}) => {
  const [inputList, setInputList] = useState({
    modification_payout_amount: "",
    modification_payout_percentage: "",
    upload_approval_document: null
  });
  const [isLoading, setIsLoading] = useState(false);
  const [modificationRow, setModificationRow] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const { baseUrl } = useContext(BaseUrl);

  useEffect(() => {
    setIsLoading(true);
    (async () => {
      await payoutDetailsWithId(match?.params?.id);
    })();
    setIsLoading(false);
  }, [match?.params?.id, payoutDetailsWithId]);

  const handleModify = () => {
    setModificationRow(true);
  };

  const handleModalHide = () => setIsModal(false);

  const handleChange = (e, field) => {
    const value = e.target ? e.target.value : e;
    const loanApprovedAmount = parseFloat(getAllThePayoutDetailsWithId?.loan_approved_amount) || 1;
  
    setInputList((prevState) => {
      const updatedInputList = { ...prevState };
  
      // Auto-calculate modification_payout_percentage if modification_payout_amount is entered
      if (field === "modification_payout_amount" && loanApprovedAmount) {
        const modificationPayoutAmount = parseFloat(value) || 0;
        const modificationPayoutPercentage = (modificationPayoutAmount / loanApprovedAmount) * 100;
  
        updatedInputList["modification_payout_percentage"] = modificationPayoutPercentage.toFixed(2);
      }
  
      // Auto-calculate modification_payout_amount if modification_payout_percentage is entered
      if (field === "modification_payout_percentage" && loanApprovedAmount) {
        const modificationPayoutPercentage = parseFloat(value) || 0;
        const modificationPayoutAmount = (modificationPayoutPercentage * loanApprovedAmount) / 100;
  
        updatedInputList["modification_payout_amount"] = modificationPayoutAmount.toFixed(2);
      }
  
      // Update the current field value
      updatedInputList[field] = value;
  
      return updatedInputList;
    });
  };

  const handleFileUpload = (val) => {
    setInputList((prevState) => ({
      ...prevState,
      upload_approval_document: val,
    }));
  };

  const handleAccept = async () => {
    const inputData = [{
      ...inputList,
      action: 'accept',
      loan_application_id: parseInt(match?.params?.id),
      modification_payout_amount: getAllThePayoutDetailsWithId?.final_payout_amount,
      modification_payout_percentage: getAllThePayoutDetailsWithId?.final_payout_percentage,
    }];

    setIsLoading(true);
    const res = await updateAllPayoutDetails(inputData);
    if(res.status === true) {
      setIsModal(true);
    }
    setIsLoading(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const inputData = [{
      ...inputList,
      action: 'modify',
      loan_application_id: parseInt(match?.params?.id),
    }];

    if(inputList['modification_payout_amount'] === '') {
      toast.error('Please enter the payout amount');
      return;
    }
    if(inputList['modification_payout_percentage'] === '') {
      toast.error('Please enter the payout percentage');
      return;
    }
    // if(!inputList['upload_approval_document']) {
    //     toast.error('Please upload the document');
    //     return;
    // }

    setIsLoading(true);
    const res = await updateAllPayoutDetails(inputData);
    if(res.status === true) {
      setIsModal(true);
    } 
    setIsLoading(false);
  };

  return (
    <Layout title={"Payout Details"} isGoback isLoading={isLoading}>
      {getAllThePayoutDetailsWithId?.track?.length > 0 ? (
        <Fragment>
          <div className="panel-card">
            <div className="panel-heading">Payout Details(Business Head)</div>
            <div className="panel-body">
              <div className="details-listing mb-5">
                <table className="table table-bordered mr-4">
                  <tbody>
                    {(() => {
                      const defaultGeneratedItem = getAllThePayoutDetailsWithId?.track.find(
                        (trackItem) => trackItem.status === "DEFAULT_GENERATED"
                      );
                      const modifiedByDSMItem = getAllThePayoutDetailsWithId?.track.find(
                        (trackItem) => trackItem.status === "MODIFIED_BY_DSM"
                      );
                      const modifiedByCentralOpsItem = getAllThePayoutDetailsWithId?.track.find(
                        (trackItem) => trackItem.status === "MODIFIED_BY_CENTRAL_OPS"
                      );
                      const modifiedByBussinessHeadItem = getAllThePayoutDetailsWithId?.track.find(
                        (trackItem) => trackItem?.status === "MODIFIED_BY_BUSINESS_HEAD"
                      );

                      if (!modifiedByDSMItem && !modifiedByCentralOpsItem && !modifiedByBussinessHeadItem) {
                        return (
                          <>
                            <tr>
                              <th>Default Payout Amount</th>
                              <td>{"Rs. " + getAllThePayoutDetailsWithId?.final_payout_amount}</td>
                            </tr>
                            <tr>
                              <th>Default Payout Percentage</th>
                              <td>{getAllThePayoutDetailsWithId?.final_payout_percentage + "%"}</td>
                            </tr>
                            <tr>
                              <th>Status</th>
                              <td>{getAllThePayoutDetailsWithId?.status}</td>
                            </tr>
                          </>
                        );
                      }

                      if (defaultGeneratedItem && (modifiedByDSMItem || modifiedByCentralOpsItem || modifiedByBussinessHeadItem)) {
                        return (
                          <>
                            <tr>
                              <th>Default Payout Amount</th>
                              <td>{"Rs. " + defaultGeneratedItem?.payout_amount}</td>
                            </tr>
                            <tr>
                              <th>Default Payout Percentage</th>
                              <td>{defaultGeneratedItem?.payout_percentage + "%"}</td>
                            </tr>
                            <tr>
                              <th>Status</th>
                              <td>{getAllThePayoutDetailsWithId?.status}</td>
                            </tr>

                            {modifiedByDSMItem && (
                              <>
                                <tr>
                                  <th>Payout Amount suggested by DSM</th>
                                  <td>{"Rs. " + modifiedByDSMItem?.payout_amount}</td>
                                </tr>
                                <tr>
                                  <th>Payout Percentage suggested by DSM</th>
                                  <td>{modifiedByDSMItem?.payout_percentage + "%"}</td>
                                </tr>
                                <tr>
                                  <th>DSM File</th>
                                  <td>
                                    <a href={modifiedByDSMItem?.payout_modification_proof_url} className="btn btn-primary btn-sm" target={'_blank'} rel="noopener noreferrer">
                                      <i className="fa fa-download"></i> Download
                                    </a>
                                  </td>
                                </tr>
                              </>
                            )}

                            {modifiedByCentralOpsItem && (
                              <>
                                <tr>
                                  <th>Payout Amount suggested by Central Ops</th>
                                  <td>{"Rs. " + modifiedByCentralOpsItem?.payout_amount}</td>
                                </tr>
                                <tr>
                                  <th>Payout Percentage suggested by Central Ops</th>
                                  <td>{modifiedByCentralOpsItem?.payout_percentage + "%"}</td>
                                </tr>
                                <tr>
                                  <th>Central Ops File</th>
                                  <td>
                                    <a href={modifiedByCentralOpsItem?.payout_modification_proof_url} className="btn btn-primary btn-sm" target={'_blank'} rel="noopener noreferrer">
                                      <i className="fa fa-download"></i> Download
                                    </a>
                                  </td>
                                </tr>
                              </>
                            )}
                            {modifiedByBussinessHeadItem && (
                              <>
                                <tr>
                                  <th>
                                    Payout Amount suggested by Business Head
                                  </th>
                                  <td>
                                    {"Rs. " +
                                      modifiedByBussinessHeadItem?.payout_amount}
                                  </td>
                                </tr>
                                <tr>
                                  <th>
                                    Payout Percentage suggested by Business Head
                                  </th>
                                  <td>
                                    {modifiedByBussinessHeadItem?.payout_percentage +
                                      "%"}
                                  </td>
                                </tr>
                                <tr>
                                  <th>Business Head File</th>
                                  <td>
                                    <a
                                      href={
                                        modifiedByBussinessHeadItem?.payout_modification_proof_url
                                      }
                                      className="btn btn-primary btn-sm"
                                      target={"_blank"}
                                      rel="noopener noreferrer"
                                    >
                                      <i className="fa fa-download"></i>{" "}
                                      Download
                                    </a>
                                  </td>
                                </tr>
                              </>
                            )}
                          </>
                        );
                      }
                      return null;
                    })()}
                  </tbody>
                </table>
                  <>
                {modificationRow && (
                  <>
                    <table className="table table-bordered mt-5 mr-4">
                      <tbody>
                        <tr>
                          <th>Suggested Payout Amount<span style={{ color: 'red' }}>*</span></th>
                          <td>
                            <ConstantInput
                              errorMsg={localization.requiredCompanyName}
                              type="number"
                              value={inputList?.modification_payout_amount}
                              handleChange={(e) => handleChange(e, 'modification_payout_amount')}
                            />
                          </td>
                        </tr>
                        <tr>
                          <th>Suggested Payout Percentage<span style={{ color: 'red' }}>*</span></th>
                          <td>
                            <ConstantInput
                              errorMsg={localization.requiredCompanyName}
                              type="number"
                              value={inputList?.modification_payout_percentage}
                              handleChange={(e) => handleChange(e, 'modification_payout_percentage')}
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <div className="col-md-4">
                      <FileUpload
                        id={"addAttachment"}
                        accept=".pdf,.png,.jpg,.jpeg,.doc,.mp4,.webm,.mkv"
                        documentUploadUrl={documentUploadUrlPublic}
                        documentUrlData={documentUrlDataPublic}
                        onChange={handleFileUpload}
                      >
                        <span className="btn btn-transparent">Upload Approval</span>
                      </FileUpload>
                    </div>

                    { (getAllThePayoutDetailsWithId.status == 'Accepted By Central Ops' || getAllThePayoutDetailsWithId.status == 'Modified By Central Ops') && (
                        <Button onClick={handleSubmit} className="btn btn-primary  mt-4 mr-3">
                        Submit
                        </Button>
                    )}
                  </>
                )}

                {!modificationRow && (getAllThePayoutDetailsWithId.status == 'Modified By Central Ops' || getAllThePayoutDetailsWithId.status == 'Accepted By Central Ops') && (
                  <div className="d-flex mb-3 mb-3">
                    <Button className="btn btn-sm btn-success mr-3" onClick={handleAccept}>
                      Accept
                    </Button>
                    <Button className="btn btn-sm btn-warning" onClick={handleModify}>
                      Modify
                    </Button>
                  </div>
                )}
                  </>

              </div>
            </div>
          </div>

          <ModalPop
            title={localization.conf}
            show={isModal}
            handleModalHide={handleModalHide}
            keyboard
            backdrop
          >
            <div className="text-center">
              <div className="success">
                <img src={Images?.tick} alt="" />
              </div>
              <h5>Updated Successfully</h5>
              <Link to={`${baseUrl}/ucd/business-head-payout-list`} className="btn btn-primary mb-4">
                Go to UCD List <img src={Images?.ArrowRight} alt="" />
              </Link>
            </div>
          </ModalPop>
        </Fragment>
      ) : (
        <Fragment>
          <div>
            <img src={Images?.NoData} alt="No data" width="100%" />
          </div>
        </Fragment>
      )}
    </Layout>
  );
};

export default PayoutDetailsForBusinessHead;
